// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"WN-z","carouselContainer":"XN-z"};